module.exports = __webpack_public_path__ + "img/swift-color.19205f4a.svg";